import React, { useEffect, useState } from "react";
import heroImg from "../assets/services page.png";

import Image1 from "../assets/High-Quality Dry Cleaning.png";
import Image2 from "../assets/Shoe & Sneaker Cleaning.png";
import Image3 from "../assets/Premium Laundry by Rapid Wash.png";

  // TESTIMONIAL DATA (ONLY)
  const testimonials = [
    {
      name: "Priya Sharma",
      text: "Amazing service! My clothes came back smelling fresh and perfectly ironed. Delivery was quick too!",
      img: "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg",
    },
    {
      name: "Rahul Verma",
      text: "Very professional laundry service. Fabric quality is maintained and packaging is neat.",
      img: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg",
    },
    {
      name: "Anjali Singh",
      text: "I trust them with my delicate clothes. No harsh smell and no damage at all.",
      img: "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg",
    },
    {
      name: "Amit Kumar",
      text: "Pickup and delivery are always on time. Their shoe cleaning service is excellent.",
      img: "https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg",
    },
    {
      name: "Neha Gupta",
      text: "Consistent quality and polite staff. Laundry has become stress-free for me.",
      img: "https://images.pexels.com/photos/1130626/pexels-photo-1130626.jpeg",
    },
  ];

 


export default function Services() {

  // SCROLL ANIMATION
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("active");
        });
      },
      { threshold: 0.15 }
    );
    elements.forEach((el) => observer.observe(el));
  }, []);
 const [index, setIndex] = useState(0);

  const prevTestimonial = () =>
    setIndex((index - 1 + testimonials.length) % testimonials.length);

  const nextTestimonial = () =>
    setIndex((index + 1) % testimonials.length);
  return (
    <>
      <style>{`
        /* ---------------- HERO ---------------- */
        .hero {
          position: relative;
          width: 100%;
          height: 50vh;
        }
        .hero img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          filter: brightness(100%);
        }
        .hero-title {
          position: absolute;
          top: 50%;
          left: 10%;
          transform: translateY(-50%);
          color: white;
          font-size: 60px;
          font-weight: 700;
        }

        /* ---------------- CARDS ---------------- */
        .cards {
          width: 80%;
          margin: 80px auto;
        }
        .grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 30px;
          margin-top: 40px;
        }
        .card {
          background: #fff;
          padding: 30px;
          border-radius: 12px;
          text-align: center;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }

        /* ---------------- CTA ---------------- */
        .cta {
          width: 100%;
          padding: 80px 20px;
          background: #1b7a9fff;
          color: white;
          text-align: center;
          margin-top: 80px;
        }
        .cta button {
          padding: 14px 28px;
          background: white;
          color: #1b7a9fff;
          font-size: 18px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
        }
/* Mobile & Tablet – High-Quality Dry Cleaning only */
@media (max-width: 768px) {
  .highlight-box[style*="row-reverse"] {
    flex-direction: column !important;
    text-align: center;
    padding: 30px 20px;
    gap: 24px;
  }

  .highlight-box[style*="row-reverse"] .highlight-img {
    width: 220px;
    height: 220px;
    margin: 0 auto;
  }

  .highlight-box[style*="row-reverse"] .highlight-text h2 {
    font-size: 26px;
  }

  .highlight-box[style*="row-reverse"] .highlight-text p {
    font-size: 16px;
    line-height: 1.6;
  }
}

        /* ---------------- HIGHLIGHT SECTION ---------------- */
        .highlight-section {
          width: 90%;
          margin: 100px auto;
        }
        .highlight-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 40px;
          margin-bottom: 80px;
          padding: 40px;
          border-radius: 30px;
          background: #f8f9ff;
          box-shadow: 0 8px 20px rgba(0,0,0,0.06);
        }
        .highlight-img {
          width: 350px;
          height: 350px;
          object-fit: cover;
        }
        .shape-circle { border-radius: 50%; }
        .shape-rounded { border-radius: 24px; }
        .shape-diamond { 
          width: 300px; 
          height: 300px; 
          transform: rotate(45deg); 
          border-radius: 20px;
        }
        .shape-diamond img {
          width: 100%; 
          height: 100%; 
          transform: rotate(-45deg); 
          border-radius: 20px; 
          object-fit: cover;
        }
        .highlight-text h2 { font-size: 36px; color: #1b7a9fff; }
        .highlight-text p { font-size: 18px; color: #444; margin-top: 10px; line-height: 1.6; }

        /* ---------------- TESTIMONIAL ---------------- */
        .testimonial-section {
          width: 90%;
          margin: 100px auto;
        }
        .testimonial-box {
          background: #ffffff;
          padding: 40px;
          border-radius: 24px;
          box-shadow: 0 6px 20px rgba(0,0,0,0.08);
          text-align: center;
          transition: 0.3s;
        }
        .testimonial-img {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          object-fit: cover;
          margin-bottom: 20px;
        }
        .testimonial-nav {
          margin-top: 20px;
          display: flex;
          justify-content: center;
          gap: 20px;
        }
        .testimonial-btn {
          padding: 10px 18px;
          background: #1b7a9fff;
          color: white;
          border: none;
          border-radius: 10px;
          cursor: pointer;
        }
          @media (max-width: 768px) {
  .hero {
    height: auto;
  }

  .hero img {
    height: auto;
    object-fit: contain;
  }
}


        /* ---------------- FAQ ---------------- */
        .faq-section {
          width: 80%;
          margin: 100px auto;
        }
        .faq-item {
          background: #f3f5ff;
          padding: 22px 28px;
          margin-bottom: 20px;
          border-radius: 16px;
          cursor: pointer;
          transition: 0.3s;
        }
        .faq-question { font-size: 20px; color: #1b7a9fff; font-weight: 600; }
        .faq-answer { margin-top: 10px; color: #444; font-size: 17px; line-height: 1.6; }

        /* ---------------- SCROLL ANIMATION ---------------- */
        .reveal { opacity: 0; transform: translateY(40px); transition: all 0.9s ease; }
        .reveal.active { opacity: 1; transform: translateY(0); }

        /* ===================== MEDIA QUERIES ===================== */
        @media (max-width: 1200px) {
          .hero-title { font-size: 50px; left: 8%; }
          .cards { width: 85%; }
          .highlight-section { width: 85%; }
          .highlight-img { width: 300px; height: 300px; }
          .shape-diamond { width: 260px; height: 260px; }
          .testimonial-box { padding: 35px; }
          .faq-section { width: 85%; }
        }

        @media (max-width: 1023px) {
          .hero { height: 45vh; }
          .hero-title { font-size: 42px; left: 6%; }
          .highlight-box { flex-direction: column; gap: 30px; text-align: center; }
          .highlight-img { width: 260px; height: 260px; margin: 0 auto; }
          .shape-diamond { width: 220px; height: 220px; }
        }

        @media (max-width: 767px) {
          .hero { height: 40vh; }
          .hero-title { font-size: 34px; left: 5%; }
          .cards { width: 95%; margin: 60px auto; }
          .cta { padding: 60px 20px; }
          .highlight-text h2 { font-size: 28px; }
          .highlight-text p { font-size: 16px; }
          .testimonial-img { width: 100px; height: 100px; }
          .faq-question { font-size: 18px; }
          .faq-answer { font-size: 16px; }
        }

        @media (max-width: 480px) {
          .hero { height: 35vh; }
          .hero-title { font-size: 30px; }
          .cta h2 { font-size: 26px; }
          .cta button { font-size: 16px; padding: 12px 24px; }
          .highlight-img { width: 220px; height: 220px; }
          .testimonial-box p { font-size: 16px; }
          .shape-diamond { width: 180px; height: 180px; }
        }

        @media (max-width: 360px) {
          .hero-title { font-size: 26px; }
          .highlight-text h2 { font-size: 24px; }
          .highlight-text p { font-size: 15px; }
          .faq-question { font-size: 17px; }
          .faq-answer { font-size: 15px; }
        }
      `}</style>

      {/* HERO */}
      <div className="hero reveal">
        <img src={heroImg} alt="Services Hero" />
        
      </div>

      {/* CARDS */}
      <div className="cards reveal">
        <h2 style={{ textAlign: "center", fontSize: "34px", color: "#1b7a9fff" }}>What We Offer</h2>
        <div className="grid">
          {[
            { icon: "🧺", title: "Regular Laundry", desc: "Perfect wash & fold service." },
            { icon: "👕", title: "Dry Cleaning", desc: "Premium dry-cleaning process." },
            { icon: "🚚", title: "Pickup & Delivery", desc: "Fast and reliable pickup." },
            { icon: "🧽", title: "Carpet Cleaning", desc: "Deep carpet washing." },
            { icon: "🔥", title: "Express Service", desc: "Done within 24 hours." },
          ].map((item) => (
            <div className="card reveal" key={item.title}>
              <div style={{ fontSize: "50px" }}>{item.icon}</div>
              <h3 style={{ marginTop: "15px" }}>{item.title}</h3>
              <p style={{ color: "#555" }}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div className="cta reveal">
        <h2>Need Professional Cleaning?</h2>
        <p style={{ marginBottom: "20px" }}>Contact us today and get a 10% discount on your first service!</p>
        <button>Book Now</button>
      </div>

      {/* HIGHLIGHTS */}
      <div className="highlight-section">
        <div className="highlight-box reveal">
          <img
            src={Image3}
            className="highlight-img shape-circle"
            alt=""
          />
          <div className="highlight-text">
            <h2>Premium Laundry by Rapid Wash</h2>
            <p>At Rapid Wash, we redefine laundry care by combining advanced cleaning technology with meticulous human attention. Every garment is treated with precision using state-of-the-art machines, fabric-safe detergents, and eco-friendly processes that preserve color, texture, and freshness. From everyday wear to delicate fabrics, our expert handling ensures deep hygiene, long-lasting softness, and a flawless finish. We focus not just on cleaning, but on delivering convenience, consistency, and care—so you get perfectly washed, neatly folded clothes without the hassle. With reliable turnaround times and uncompromising quality, Rapid Wash turns routine laundry into a premium experience you can trust.</p>
          </div>
        </div>

        <div className="highlight-box reveal" style={{ flexDirection: "row-reverse" }}>
          <img
            src={Image1}
            className="highlight-img shape-rounded"
            alt=""
          />
          <div className="highlight-text">
            <h2>High-Quality Dry Cleaning</h2>
            <p>High-quality dry cleaning designed to protect what matters most. From delicate fabrics to expensive outfits, each garment is treated with specialized, chemical-free cleaning methods that remove stains effectively while preserving fabric texture, color, and shape. Our process ensures deep cleanliness without harsh residues, extending the life and elegance of your clothes.</p>
          </div>
        </div>

        <div className="highlight-box reveal">
          <div className="shape-diamond">
            <img src={Image2} alt="" />
          </div>
          <div className="highlight-text">
            <h2>Shoe & Sneaker Cleaning</h2>
            <p>Restore the original freshness of your shoes with deep cleaning, polishing, and deodorizing.</p>
          </div>
        </div>
      </div>

      {/* TESTIMONIAL */}
<div className="testimonial-section reveal">
  <h2 style={{ fontSize: "34px", textAlign: "center", color: "#1b7a9fff" }}>
    What Our Customers Say
  </h2>

  <div className="testimonial-box reveal">
    <img
      src={testimonials[index].img}
      className="testimonial-img"
      alt={testimonials[index].name}
    />
    <p style={{ fontSize: "18px", color: "#444" }}>
      "{testimonials[index].text}"
    </p>
    <h3 style={{ marginTop: "12px", color: "#1b7a9fff" }}>
      — {testimonials[index].name}
    </h3>
  </div>

  <div className="testimonial-nav">
    <button className="testimonial-btn" onClick={prevTestimonial}>
      ← Previous
    </button>
    <button className="testimonial-btn" onClick={nextTestimonial}>
      Next →
    </button>
  </div>
</div>

      {/* FAQ */}
      <div className="faq-section">
        {[
          { q: "How long does delivery take?", a: "Most orders are delivered within 24–48 hours depending on the service." },
          { q: "Do you offer express service?", a: "Yes, express delivery is available for urgent laundry needs." },
          { q: "Is pickup and delivery free?", a: "Yes! Pickup and delivery are free for all orders above ₹199." }
        ].map((item) => (
          <div className="faq-item reveal" key={item.q}>
            <div className="faq-question">{item.q}</div>
            <div className="faq-answer">{item.a}</div>
          </div>
        ))}
      </div>
    </>
  );
}
